import { getLayerName, getZOrder } from './get-common-properties';
import { updateLayerName, updateZOrder } from './update-common-properties';

export const zOrderAPI = {
  getLayerName,
  getZOrder,
  updateLayerName,
  updateZOrder,
};
